/**
 * Đường dẫn riêng của simulator trong trình duyệt; không gửi tới Backend live.
 * Mã trong chú thích là ID API trong Excel (IAM-01, TR-02…).
 */
export const mockEndpoints = {
  auth: {
    login: '/v1/auth/login', // IAM-01 (SĐT + mã mở khoá 6 số – theo ảnh S01→S02)
    refresh: '/v1/auth/refresh', // IAM-03
    logout: '/v1/auth/logout', // IAM-04
    me: '/v1/me', // IAM-02
  },
  places: {
    search: '/v1/places/search', // MP-01
  },
  quotes: { create: '/v1/quotes' }, // TR-01
  trips: {
    create: '/v1/trips', // TR-02 (202 + commandId)
    list: '/v1/trips', // TR-03
    detail: (id: string) => `/v1/trips/${encodeURIComponent(id)}`, // TR-04
    cancel: (id: string) => `/v1/trips/${encodeURIComponent(id)}/cancel`, // TR-05
    confirm: (id: string, step: 'pickup' | 'complete') => `/v1/trips/${encodeURIComponent(id)}/confirm-${step}`, // TR-05
    timeline: (id: string) => `/v1/trips/${encodeURIComponent(id)}/timeline`, // TR-08
    plans: (id: string) => `/v1/trips/${encodeURIComponent(id)}/change-plans`, // CS-02
  },
  commands: { detail: (id: string) => `/v1/commands/${encodeURIComponent(id)}` }, // CM-02
  plans: {
    detail: (id: string) => `/v1/change-plans/${encodeURIComponent(id)}`, // PR-02 (+ RT-02 routes)
    consent: (id: string) => `/v1/change-plans/${encodeURIComponent(id)}/consent`, // PR-04
    reject: (id: string) => `/v1/change-plans/${encodeURIComponent(id)}/reject`, // PR-04
    withdraw: (id: string) => `/v1/change-plans/${encodeURIComponent(id)}/withdraw`, // PR-05
    refresh: (id: string) => `/v1/change-plans/${encodeURIComponent(id)}/refresh`, // PR-02 (lấy phiên bản mới khi hết hạn)
  },
  support: {
    sos: '/v1/support/sos', // SP-01
    requests: '/v1/support/requests', // SP-02 (POST) / SP-03 (GET list)
    detail: (id: string) => `/v1/support/requests/${encodeURIComponent(id)}`, // SP-04 (+ SP-06 history)
  },
  notifications: {
    list: '/v1/notifications', // NT-01
    seen: (id: string) => `/v1/notifications/${encodeURIComponent(id)}/seen`, // NT-02
  },
  home: { feed: '/v1/home/feed' }, // (giả định) quảng cáo + gợi ý quán – nội dung động
  events: '/v1/events', // NT-03 (SSE)
} as const;
